import React, { useEffect, useState } from "react"
import Link from "next/link"

import { getPdpRedirectUrl } from "@/utils/index"
import { getPDPUrl } from "@/utils/helper"
import Style from "@/components/Bundles/StaticBundle/BundlesAccordian/Feature/index.module.scss"
import { viewMoreBundleFeature } from "@/components/Bundles/analytics"

const Feature = props => {
  const { data } = props
  const { productFeatures = [], name = "", sku, category, slug } = data

  const [productUrl, setProductUrl] = useState([])

  useEffect(() => {
    if (category && slug && sku) {
      getPDPUrl(category, slug).then(pdpUrl => {
        const param = sku ? `skuId=${sku}` : ""
        const redirectUrl = getPdpRedirectUrl(pdpUrl, param)
        setProductUrl(redirectUrl)
      })
    }
  }, [category, slug, sku])

  const viewMoreBundleFeatureClick = (url = "") => {
    viewMoreBundleFeature(url)
  }

  return (
    <div key={sku} className={`col-12 ${Style.Feature}`}>
      <p className="title">{name}</p>
      <ul className="lists">
        {productFeatures.slice(0, 3).map((fl, i) => (
          <li key={i}>{fl}</li>
        ))}
      </ul>
      <Link
        href={productUrl}
        className="link"
        onClick={() => viewMoreBundleFeatureClick(productUrl)}
      >
        View More
      </Link>
    </div>
  )
}

export default Feature
